/* eslint-disable jsx-a11y/anchor-is-valid */
import Modal from '@material-ui/core/Modal';
import { StyledComponentProps, StyleRules, withStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { Component } from 'react';
import { Trans } from 'react-i18next';
import ContactUs from './ContactUs';

const pageStyles: StyleRules = {
  bottomBar: {
    position: 'fixed',
    bottom: '0%',
    width: '100%',
    backgroundColor: '#585858',
    padding: '16px',
  },
  barContent: {
    paddingRight: '7px',
    borderRightWidth: '2px',
    borderRightColor: '#D7D7D7',
    borderRightStyle: 'solid',
    color: '#ffffff',
  },
  email: {
    paddingLeft: '7px',
    color: '#ffffff',
    '&:visited': {
      color: '#D7D7D7',
    },
  },
};

function getModalStyle() {
  const top = 25;
  const left = 28;
  const right = 28;

  return {
    top: `${top}%`,
    left: `${left}%`,
    right: `${right}%`,

    // transform: `translate(-${top}%, -${left}%)`,
  };
}

interface Props {
  jurisdictionCode: string;
  subJurisdictionCode?: string;
  locale?: string;
  contactInfoUri?: string;
}

interface State {
  open: boolean;
}

class BottomBar extends Component<Props & StyledComponentProps, State> {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
  }

  public render() {
    const classes = this.props.classes!;
    return (
      <div className={classes.bottomBar}>
        <a href="javascript: void(0);" onClick={this.handleOpen} className={classes.email}>
          <Trans>contact_us</Trans>
        </a>
        <Modal
          style={getModalStyle()}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
        >
          <div id="ContactModal" role="dialog">
            <ContactUs
              onClose={this.handleClose}
              jurisdiction={this.props.jurisdictionCode}
              subJurisdiction={this.props.subJurisdictionCode}
              locale={this.props.locale}
              contactInfoUri={this.props.contactInfoUri}
            />
          </div>
        </Modal>
      </div>
    );
  }

  private handleOpen() {
    this.setState({ open: true });
  }

  private handleClose() {
    this.setState({ open: false });
  }
}

export default withStyles(pageStyles)(BottomBar);
